import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAP9KxhRcTH9geQ7u2jRIFZRaIQdZ4nrZE",
  authDomain: "login-qero.firebaseapp.com",
  projectId: "login-qero",
  storageBucket: "login-qero.firebasestorage.app",
  messagingSenderId: "483980712136",
  appId: "1:483980712136:web:877dc9e380c96cd8a2edfd",
  measurementId: "G-YN43NW7GS1"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
